import { SeeAllPopup } from '@aibees/elephant/components/see-all-popup';
import { classnames } from '@aibees/shared/utils';
import { Button, Stack, Typography } from '@mui/material';
import { memo, useState } from 'react';
import { TagChip } from '../tag-chip';
import * as Styled from './styles';
import * as SX from './sx';
import type { TagsProps as Props } from './types';

export const Tags = memo(
  ({
    className,
    items,
    limit,
    displayTags,
    config,
    title,
    icon,
    isDetailPopover,
  }: Props) => {
    displayTags = displayTags ?? limit;
    const [showAllTags, setShowAllTags] = useState(false);

    const displayList = items?.slice(
      0,
      items.length > limit ? displayTags : limit
    );

    const allTagsList = items;

    const showSeeAllButton = items && items.length > limit;
    const hasItems = items && items.length > 0;

    const handleToggleSeeMore = () => {
      setShowAllTags(!showAllTags);
    };

    return (
      <Styled.Wrapper className={classnames('Tags', className)} sx={SX.root}>
        {hasItems ? (
          <Stack sx={SX.content}>
            {(isDetailPopover && showAllTags ? allTagsList : displayList)?.map(
              (x, _index) => (
                <TagChip key={x.label} item={x} config={config} />
              )
            )}

            {showSeeAllButton && (
              <>
                {isDetailPopover ? (
                  <Button
                    variant="text"
                    size="xsmall"
                    color="primary"
                    onClick={handleToggleSeeMore}
                  >
                    {showAllTags ? 'Show Less' : 'Show More'}
                  </Button>
                ) : (
                  <SeeAllPopup
                    icon={icon}
                    items={
                      items?.map((x, index) => ({
                        text: x.label,
                        key: index.toString(),
                        element: (
                          <TagChip key={index} config={config} item={x} />
                        ),
                      })) || []
                    }
                    placeholder={config?.placeholder}
                    title={title}
                    buttonTitle="See All"
                  />
                )}
              </>
            )}
          </Stack>
        ) : (
          <Typography variant="body4" color="grey.500" fontWeight={400}>
            No information available.
          </Typography>
        )}
      </Styled.Wrapper>
    );
  }
);

Tags.displayName = 'Tags';
